import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AuthProvider } from './lib/AuthContext.js';
import { ThemeProvider } from './lib/ThemeContext.js';
import { AnalyticsTracker } from './components/AnalyticsTracker.js';
import { bootExtensionHandshake } from './lib/extensionBridge.js';
import './styles.css';

// Boot the postMessage listener BEFORE React renders so we never miss the
// extension's initial handshake (it fires at document_start).
bootExtensionHandshake();

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AnalyticsTracker />
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
